import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  PayItemConnection,
  useConnectionsContext,
} from '../../ConnectionsContext'
import { useRestorePayItemConnectionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'

export function useRestore(): RestoreRowActionOptions<PayItemConnection> {
  const { refetch } = useConnectionsContext()
  const [restore] = useRestorePayItemConnectionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restorePayItemConnection: {
        payItemConnection: { googleSheet, name },
      },
    }) =>
      simpleRestoreNotification(name ?? googleSheet?.title ?? 'Google Sheet'),
  })
  return {
    permission: Permission.RemoveRestorePayItemConnection,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
  }
}
